import { IStockState } from "./reducer";
const initialState: IStockState = {
  stock: [],
  isFetchingStock: false,
};

export default initialState;
